import type { Theme } from '@mui/material/styles'

const MuiMenuItem = (baseTheme: Theme) => ({
  styleOverrides: {
    root: {
      columnGap: baseTheme.spacing(0.5),
      padding: baseTheme.spacing(0.5, 1.25),
      background: baseTheme.palette.neutral.white,

      [baseTheme.breakpoints.up('md')]: {
        padding: baseTheme.spacing(0.75, 2),
      },

      '&:hover, &:focus-visible': {
        background: baseTheme.palette.neutral.lightest,
        zIndex: 1,
      },

      '& > .MuiListItemIcon-root': {
        minWidth: baseTheme.spacing(1),
        color: baseTheme.palette.neutral.dark,
      },
    },
  },
})

export default MuiMenuItem
